import i18next from "i18next";
import moment from 'moment';
import 'moment/locale/fi';
import 'moment/locale/en-gb';
import React, {JSX} from "react";

if (!i18next.isInitialized) {
  i18next.init({
    lng: 'fi',
    fallbackLng: 'en',
    resources: {},
    interpolation: { escapeValue: false },
  });
}

const translateService = {
  translate: (key: string, lang?: string): string =>
      i18next.t(key, { lng: lang }),

  localize: (date: string): string =>
      moment(date).format('l LT'),

  fromNow: (startDate: string): string =>
      moment(startDate).fromNow(),

  setLocale: (lang: string): void => {
    i18next.changeLanguage(lang).then(r => {});
    moment.locale(lang);
  },

  registerTranslations: (lang: string, langObject: any): void => {
    i18next.addResourceBundle(lang, 'translation', langObject, true, true);
  },
};

export { translateService };

interface TranslateProps {
  content: string;
  component?: keyof JSX.IntrinsicElements;
  className?: string;
  unsafe?: boolean;
  [key: string]: any; // for other props
}

export const Translate: React.FC<TranslateProps> = ({
                                                      content,
                                                      component: Component = "span",
                                                      className,
                                                      unsafe,
                                                      ...rest
                                                    }) => {
  const translation = translateService.translate(content);

  if (unsafe) {
    return (
        <Component
            className={className}
            dangerouslySetInnerHTML={{ __html: translation }}
            {...rest}
        />
    );
  }

  return (
      <Component className={className} {...rest}>
        {translation}
      </Component>
  );
};